import React from 'react';

const AreaIcon = () => {
  return (
    <svg width="22" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 20.0112H20V0.91011L0 20.0112ZM18 18.1011H4.83L18 5.52303V18.1011Z" fill="currentColor" />
    </svg>
  )
};

export default AreaIcon;
